import { ModeToggle } from '@/components/theme/toggle-theme-button'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <div className="flex flex-col h-full p-6 gap-4">
      <ModeToggle />
      <Outlet />
    </div>
  )
}
